import React from 'react';
import UserManagementPortal from './UserManagementPortal';

const UserManagement: React.FC = () => {
  return <UserManagementPortal />;
};

export default UserManagement;
